<template>
  <v-snackbar
    v-model="snackbar"
    bottom
    absolute
    style="z-index: 100"
    :timeout="-1"
  >
    {{ text }}

    <template v-slot:action="{ attrs }">
      <v-btn
        color="light-green accent-4"
        @click="verifyEmail()"
        text
        v-bind="attrs"
      >
        Resend email
      </v-btn>
      <v-btn
        color="white"
        class="ml-2"
        @click="snackbar = false"
        icon
        v-bind="attrs"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    snackbar: false,
    text: "Your email address is unverified."
  }),
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  methods: {
    open() {
      this.snackbar = true;
    },
    close() {
      this.snackbar = false;
    },
    verifyEmail() {
      if (!this.user) return;
      this.$socket.emit(
        "resend verification email",
        {
          userID: this.user.id,
          token: localStorage.getItem("token")
        },
        output => {
          if (output.success == true) {
            this.snackbar = false;
            this.$root.$alert(
              "Success",
              "Verification email resent to <b>" +
                this.user.email.address +
                " </b>."
            );
          } else {
            switch (output.code) {
              case 0:
                this.$root.$alert(
                  "Unknown Error",
                  "Unable to resend verification email. Please try again later",
                  {
                    color: "red accent-4"
                  }
                );
                break;
              case 1:
                this.$root.$alert(
                  "Error",
                  "You're doing that too much! Try again later.",
                  {
                    color: "red accent-4"
                  }
                );
                break;
            }
          }
        }
      );
    }
  }
};
</script>
